import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * ProtectedRoute component that checks if user is authenticated
 * If not authenticated, redirects to login page with return URL
 */
const ProtectedRoute = ({ children }) => {
	const { isAuthenticated, loading } = useAuth();
	const location = useLocation();

	// If still loading auth state, show nothing or a loading spinner
	if (loading) {
		return null; // or return a loading spinner component
	}

	// If not authenticated, redirect to login with the return URL
	if (!isAuthenticated) {
		return <Navigate to="/login" state={{ from: location.pathname }} replace />;
	}

	// If authenticated, render the protected route's children
	return children;
};

export default ProtectedRoute;
